const News = () => (
    <div className="page-content">
        <h1>News</h1>
        <p>Bienvenue sur la page News.</p>
    </div>
);

export default News;